/** Объект-холдер кратких форм справочников (для выпадашек) */
export const setDirectoryShorts = (shorts) => {
  return {type: 'SET_DIRECTORY_SHORTS', payload:shorts};
};
/** Массив список тех справочников, которые уже были зсгружены */
export const setDirectoryLoaded = (loaded) => {
  return {type: 'SET_DIRECTORY_LOADED', payload:loaded};
};
